// extracted by mini-css-extract-plugin
export default {"modal":"UploadVersionModal_modal__CfrZ4"};